import { useNavigate } from "react-router-dom";
import ButtonComponent from "../../components/ButtonComponent";
import { RESTAURANT_ID } from "../../constants/constans";
import { useCallback, useEffect, useMemo, useState } from "react";
import "./index.css";
import NewArrival from "../../assets/images/NewArrival.PNG";
import ArrivalBadge from "../../assets/images/ArrivalBadge.PNG";
import { useGetInitialDataQuery } from "../../redux/services/initialDataService";
import { Alert } from "reactstrap";
import { useDispatch } from "react-redux";
import { setInitialData } from "../../redux/initialDataSlice";
import {
  fetchRestaurantFailure,
  fetchRestaurantStart,
  fetchRestaurantSuccess,
} from "../../redux/restaurantSlice";
import { useGetRestaurantByIdMutation } from "../../redux/services/getRestaurant";
import {
  useGetMenuCustomListFromCustomerSiteQuery,
  useGetMenuSetListFromCustomerSiteQuery,
  useGetMenuSingleListFromCustomerSiteQuery,
} from "../../redux/services/setMenuService";
import img2 from "../../assets/images/Defult.PNG";
import { useAuth } from "../../context/AuthContext";
import Dashboard01 from "../Main Design/Dashboard01";
import RotatingItems from "../Main Design/FoodRotateMenu";
import Dashboard02 from "../Main Design/Dashboard02";
import OurPromise from "../Main Design/OurPromise";
import SignatureDishes from "../Main Design/SignatureDishes";
import Dashboard03 from "../Main Design/Dashboard03";
import CustomerFeedBack from "../Main Design/CustomerFeedBack";
import ReadyToFeast from "../Main Design/ReadyToFeast";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowUpRightDots } from "@fortawesome/free-solid-svg-icons";

export interface MenuItem {
  portions: any;
  supportPortionSizes: any;
  id: string;
  items: any;
  imageUrl: any;
  displayName: string;
  itemId: string;
  itemType: string;
  price: number;
  allergenInformation?: string[];
  foodAttributes?: string[];
  availableDays?: number[];
  availableItemCount?: number;
  isAvailable: boolean;
  supportsPreOrdering?: boolean;
  filterTags?: string[];
  tags: any;
  description?: string;
}

const Home = () => {
  const { isAuthenticated, isLoading: authLoading } = useAuth();
  const restaurantId = RESTAURANT_ID;
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [isPageLoading, setIsPageLoading] = useState<boolean>(false);
  // please don't  delete comment sections
  // const { data: initialData, isLoading, error } = useGetInitialDataQuery();
  const { data: initialData, error } =
    useGetInitialDataQuery(undefined, { skip: !isAuthenticated });
  // const { data: initialData, error } = useGetInitialDataQuery();
  const [getRestaurantById] = useGetRestaurantByIdMutation();

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const { data: singleMenuData, isLoading: singleMenuLoading } =
    useGetMenuSingleListFromCustomerSiteQuery(restaurantId, { skip: !isAuthenticated });

  const { data: setMenuData, isLoading: setMenuLoading } =
    useGetMenuSetListFromCustomerSiteQuery(restaurantId, { skip: !isAuthenticated });

  const { data: customMenuData } =
    useGetMenuCustomListFromCustomerSiteQuery(restaurantId, { skip: !isAuthenticated });

  const [currentIndex, setCurrentIndex] = useState(0);
  // const [animate, setAnimate] = useState(false);
  useEffect(() => {
    if (initialData) {
      dispatch(setInitialData(initialData));
    }
  }, [initialData, dispatch]);

  useEffect(() => {
    if (singleMenuLoading || setMenuLoading) {
      setIsPageLoading(true);
    } else {
      setIsPageLoading(false);
    }
  }, [isPageLoading, singleMenuLoading, setMenuLoading]);

  useEffect(() => {
    if (!isAuthenticated) return;

    const fetchRestaurant = async () => {
      dispatch(fetchRestaurantStart());
      try {
        const response = await getRestaurantById(restaurantId).unwrap();
        dispatch(fetchRestaurantSuccess(response));
      } catch (error) {
        dispatch(fetchRestaurantFailure("Failed to load restaurant"));
      }
    };

    fetchRestaurant();
  }, [isAuthenticated, restaurantId, dispatch, getRestaurantById]);
  if (error) {
    <Alert>Error Loading Data</Alert>;
  }

  const handleClickNavigate = () => {
    navigate("/order");
  };

  const findProductDetails = useCallback(
    (itemId: string, itemType: string) => {
      switch (itemType) {
        case "MenuItem":
          return singleMenuData?.menusItems?.find(
            (item: MenuItem) => item.id === itemId || item.itemId === itemId
          );
        case "setMenu":
          return setMenuData?.setMenus?.find(
            (item: MenuItem) => item.id === itemId || item.itemId === itemId
          );
        case "customMenu":
          return customMenuData?.customMenus?.find(
            (item: MenuItem) => item.id === itemId || item.itemId === itemId
          );
        default:
          return null;
      }
    },
    [singleMenuData, setMenuData, customMenuData]
  );

  const newArrivalsWithDetails = useMemo(() => {
    if (!initialData?.home?.newArrivals) return [];
    return initialData.home.newArrivals
      .map((item) => {
        const details = findProductDetails(item.id, item.itemType);
        return {
          dish: details?.displayName || "Unknown Dish",
          description: details?.description || "",
          price: details?.price ? `LKR ${details.price}` : "",
          image: details?.imageUrl || img2,
        };
      })
      .filter((item) => item.dish && item.image);
  }, [initialData, findProductDetails]);

  const current = newArrivalsWithDetails[currentIndex];
  return (
    <>
      {authLoading ? (
        <div>
          <div className="loader-wrapper">
            <div className="loader"></div>
          </div>
        </div>
      ) : (
        <div>
          <Dashboard01 />
          <RotatingItems />
          <Dashboard02 />
          <OurPromise />
          <SignatureDishes />
          <Dashboard03 />
          {/* New Arrival section */}
          {/* <NewArrival/> */}
          {newArrivalsWithDetails.length > 0 && (
            <div className="new-arrival-section" style={{
              backgroundImage: `url(${NewArrival})`,
              backgroundSize: 'cover',
              backgroundPosition: 'center',
              minHeight: '600px',
              position: 'relative',
              overflow: 'hidden',
              display: 'flex',
              alignItems: 'center'
            }}>
              {current && (
                <div className="container-fluid">
                  <div className="row align-items-center">
                    {/* Left Content */}
                    <div className="col-md-6">
                      <div className="newarrival-left">
                        <h1 className="newarrival-title">New Arrival!</h1>
                        <h2 className="newarrival-dish">{current.dish}</h2>
                        <p className="newarrival-description">{current.description}</p>
                        <hr className="newarrival-divider" />
                        <div className="newarrival-price-row">
                          <span className="newarrival-price-label">Product Price</span>
                          <span className="newarrival-price">{current.price}</span>
                        </div>
                        <hr className="newarrival-divider" />
                        <div>
                          <ButtonComponent
                            title="Order Now"
                            icon={<FontAwesomeIcon icon={faArrowUpRightDots} />}
                            onClick={handleClickNavigate}
                            backgroundColor="#000000"
                            color="#FFFFFF"
                          />
                        </div>
                      </div>
                    </div>
                    {/* Right Image */}
                    <div className="col-md-6">
                      <div className="newarrival-right">
                        <div className="newarrival-image-container">
                          <img
                            src={current.image}
                            alt={current.dish}
                            className="newarrival-img"
                            draggable={false}
                            onError={(e) => {
                              e.currentTarget.src = img2;
                            }}
                          />
                          <img
                            src={ArrivalBadge}
                            alt="Arrival Badge"
                            className="arrival-badge"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* Dots */}
                  <div className="newarrival-pagination">
                    {newArrivalsWithDetails.map((_, index) => (
                      <span
                        key={index}
                        className={`dot ${currentIndex === index ? "active" : ""}`}
                        onClick={() => setCurrentIndex(index)}
                      />
                    ))}
                  </div>
                </div>
              )}
            </div>)}
          <CustomerFeedBack />
          <ReadyToFeast />
        </div>
      )}
    </>
  );
};

export default Home;
